import React from 'react';
import { 
  Circle,
  Clock,
  AlertCircle,
  CheckCircle,
  XCircle
} from 'lucide-react';

/**
 * TicketStatusBadge Component
 * Displays ticket status with appropriate color and icon
 */
export const TicketStatusBadge = ({ status }) => {
  const statusConfig = {
    new: {
      label: 'New',
      color: 'bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-300',
      icon: Circle,
    },
    open: {
      label: 'Open',
      color: 'bg-purple-100 text-purple-800 dark:bg-purple-900/20 dark:text-purple-300',
      icon: AlertCircle,
    },
    pending: {
      label: 'Pending',
      color: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/20 dark:text-yellow-300',
      icon: Clock,
    },
    resolved: {
      label: 'Resolved',
      color: 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-300',
      icon: CheckCircle,
    },
    closed: {
      label: 'Closed',
      color: 'bg-gray-100 text-gray-800 dark:bg-gray-900/20 dark:text-gray-300',
      icon: XCircle,
    },
  };

  const config = statusConfig[status] || statusConfig.new;
  const Icon = config.icon;

  return (
    <span
      className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium ${config.color}`}
    >
      <Icon className="w-3 h-3" />
      {config.label}
    </span>
  );
};

export default TicketStatusBadge;
